import { Tabs as MuiTabs } from "@mui/material";
import styled from "styled-components";

const StyledMuiTabs = styled(MuiTabs)`
  .MuiTab-root {
    text-transform: none;
  }
`;

export const Tabs = StyledMuiTabs;
